import React from 'react'
import cx from 'classnames'

import { CheckedIcon } from './icons/CheckedIcon'
import { IndeterminateIcon } from './icons/IndeterminateIcon'

import cm from './CheckboxContainer.module.css'

export const CheckboxContainer = ({
  checked,
  disabled,
  invalid,
  indeterminate,
}: {
  checked?: boolean
  invalid?: boolean
  disabled?: boolean
  indeterminate?: boolean
}) => {
  return (
    <div
      className={cx(cm.checkbox__iconContainer, {
        [cm.checked]: checked || indeterminate,
        [cm.disabled]: disabled,
        [cm.invalid]: invalid,
        [cm.indeterminate]: indeterminate,
      })}
    >
      {checked && !indeterminate && <CheckedIcon className={cx(cm.checkbox__icon)} />}
      {indeterminate && <IndeterminateIcon className={cx(cm.checkbox__icon)} />}
    </div>
  )
}
